import axios from 'axios';
import {getJwtToken} from '../services/jwt.services';

const BASE_URL = process.env.REACT_APP_BASE_URL;
class alerttrackingServiceController {
  async addCompany(companyid,companyname) {
  
    
    const jwtToken = getJwtToken();
    try {
      const reqbody = {
        "companyid": companyid,
        "companyname": companyname
      }
      const apiUrl = `${BASE_URL}/alerttracking/newsletters/add`;
      console.log("SEND ",apiUrl)
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
     
      
      const result = await axios.post(apiUrl, reqbody,{headers});
      console.log('result', result);
      return [result];
    } catch (_e) {
      const status = [{reason: ""}];
      
      return {"status":"fail", data: status}
      //return [];
    }
  }

  async removeCompany(company) {
  
    
    const jwtToken = getJwtToken();
    try {
   
      const apiUrl = `${BASE_URL}/alerttracking/newsletters/remove/${company.companyId}`;
      console.log("SEND ",apiUrl)
      const headers = {
        'Authorization': `Bearer ${jwtToken}`,
        'Content-Type': 'application/json', // Adjust the content type if needed
      };
      const result = await axios.delete(apiUrl, {headers});
      console.log('result', result);
      return [result];
    } catch (_e) {
      const status = [{reason: ""}];
      
      return {"status":"fail", data: status}
      //return [];
    }
  }
}

export const AlertTrackingService = new alerttrackingServiceController();
